import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=8806990e&"
var script = {}
import style0 from "./ButtonGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports